export default {
  getCities(state) {
    return state.cities;
  },
  getSegments(state) {
    return state.segments;
  },
  getIbgeCities(state) {
    return state.ibgeCities;
  },
  getImagesAddress() {
    return process.env.VUE_APP_IMAGES_ADDRESS;
  },
  getImagesAddressApp() {
    return process.env.VUE_APP_IMAGES_ADDRESS_APP;
  },
  getImagesAddressAppAws() {
    return process.env.VUE_APP_FOTOS_CATEGORIA_URL;
  },
  getImagesProductsAws() {
    return process.env.VUE_APP_FOTOS_URL;
  },
  getApiUrl() {
    return process.env.VUE_APP_API_URL;
  },
};
